import { RailyticsParameters } from "./models"

function getDomain(url: string) {
  if (!url) { return '' }
  url = decodeURIComponent(url)
  url = url.split('://')[1]
  // const test = RegExp('^(?:[^/]+://)?([^/:]+)', 'g')
  const test = /^(?:[^/]+:\/\/)?([^/:]+)/g
  if (typeof url !== 'undefined') {
    const m = url.match(test)
    url = m ? m[0] : ''
  }
  return (url ?? '').toLowerCase()
}

function isOwnDomain(url: string, domain = '') {
  if (domain) {
    if (domain.toUpperCase().startsWith('REGEXP:')) {
      const reg = RegExp(domain.substring(7), 'i')
      if (reg.test(getDomain(url))) { return true }
    } else {
      const domains = domain.split(';')
      url = getDomain(url)
      for (const d of domains) {
        if (url === d) { return true }
      }
    }
  }
  return false
}

export function checkCustomParameter(params: Record<number, string>, prefix: string) {
  let par = ''
  for (const key in params) {
    if (!isNaN(parseInt(key))) {
      par += '&' + prefix + key + '=' + encodeURIComponent(params[key])
    }
  }
  return par;
}

export function baseparams(config: RailyticsParameters, sentFullPixel?: string) {
  let c = `${screen.width}x${screen.height},${screen.colorDepth ?? screen.pixelDepth},`
  c += `${(navigator.cookieEnabled ? '1,' : '0,')}${new Date().getTime()},`
  let b = '0'
  if (document.referrer.length) { b = encodeURIComponent(document.referrer) }
  if (sentFullPixel) { b = sentFullPixel; }
  else if (isOwnDomain(b, config.domain)) { b = '1' }
  else { b = decodeURIComponent(b); }
  let height = window.innerHeight
  if (!height) { try { height = document.documentElement.clientHeight } catch {/* empty */} }
  if (!height) { try { height = document.body.clientHeight } catch {/* empty */} }
  if (typeof height === 'undefined') { height = -1 }
  let width = window.innerWidth
  if (!width) { try { width = document.documentElement.clientWidth } catch {/* empty */} }
  if (!width) { try { width = document.body.clientWidth } catch {/* empty */} }
  if (typeof width === 'undefined') { width = -1 }
  if (height && height > screen.height) { height = screen.height }
  if (width && width > screen.width) { width = screen.width }
  c += `${b},${width}x${height},${typeof navigator.javaEnabled === 'function' ? navigator.javaEnabled() ? '1' : '0' : '0'}`
  return c;
}
